module.exports = __webpack_public_path__ + "img/star_icon.f3c6dcc0.png";